<script>
// import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
// import PageHeader from "@/components/page-header";
import axios from "axios";
import Swal from "sweetalert2";
import CryptoJS from "crypto-js";
import CardListAssessmen from "./components/card-list-assessmen.vue";
import CardListAssessmenProfesi from "./components/card-list-assessmen-profesi.vue";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Dashboard",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    // Layout,
    // PageHeader,
    CardListAssessmen,
    CardListAssessmenProfesi,
  },
  data() {
    return {
      title: "Dashboard",
      items: [
        {
          text: "Dashboards",
          href: "/",
        },
        {
          text: "Default",
          active: true,
        },
      ],
      namePathUrl: this.$route.name,
      sessionRoleId: localStorage.session_role_active_id,
      user_name: localStorage.session_name,
      pathPhoto: localStorage.session_path_photo,
      pathPhotoFull:
        process.env.VUE_APP_BACKEND_URL + localStorage.session_path_photo,
      dataListJadwal: [],
      nama_peserta: "-",
      jabatan_peserta: "-",
      data_peserta: null,
      app_sso: "",
      token_jadwal: "",
      isOpen: false,
      configs: {},
      info_ujian: "",
      isDone: true,
      isSimulasi: false,
    };
  },
  computed: {
    isPegawai() {
      return localStorage.getItem("user_pegawai") === "pegawai_internal";
    },
  },
  methods: {
    kembaliKeDashboardPegawai() {
      this.$router.push({ name: "dashboard-pegawai" });
    },
    async getConfig() {
      const data = await axios({
        method: "get",
        url: process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/konfig-login",
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
        },
      }).then((response) => response.data.data);
      if (data) {
        this.configs = data.referensi;
      }
    },
    async getInfoUjian(id = "") {      
      const data = await axios({
        method: "get",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "referensi/info-ujian/peserta",
        params: {
          idjadwal_pelaksanaan: id,
        },
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
        },
      }).then((response) => response.data.data);
      if (data) {
        this.info_ujian = data;
        // console.clear();
        // console.log(data);
      }
    },
    async saveToLocalStorage() {
      Swal.fire({
        title: "Loading...",
        allowOutsideClick: false,
        showConfirmButton: false,
        onBeforeOpen: () => {
          Swal.showLoading();
        },
      });
      const ssoTokenParam = this.$route.query.sso;
      const isSimulasi = this.$route.query.isSimulation ?? false;

      if (ssoTokenParam) {
        var config_axios = {
          method: "post",
          url: process.env.VUE_APP_BACKEND_URL_VERSION + "auth/login-sso",
          data: {
            sso: ssoTokenParam,
          },
          headers: {
            Accept: "application/json",
          },
        };
        await axios(config_axios)
          .then((response) => {
            let response_data_fix = response.data;
            if (response.data.meta.code == 200) {
              localStorage.setItem(
                "access_token_peserta",
                response.data.data.access_token
              );
              localStorage.setItem("nip_peserta", response.data.data.user.nip);
              localStorage.setItem(
                "nama_peserta",
                response.data.data.user.nama
              );
              localStorage.setItem(
                "jabatan_peserta",
                response.data.data.user.jabatan_nama
              );
              localStorage.setItem(
                "data_peserta",
                JSON.stringify(response.data.data.user)
              );
              localStorage.setItem("is_simulasi", isSimulasi);
              this.isSimulasi = localStorage.getItem("is_simulasi") == "true";
              (this.nama_peserta = localStorage.nama_peserta),
                (this.jabatan_peserta = localStorage.jabatan_peserta);
              this.data_peserta = JSON.parse(localStorage.data_peserta);
              this.app_sso = response.data.data.app_sso;
              this.token_jadwal = response.data.data.token_jadwal;
              localStorage.setItem("app_sso", this.app_sso);
              localStorage.setItem("app_sso", this.app_sso);
              localStorage.setItem("token_jadwal", this.token_jadwal);
              // console.log(response_data_fix);
              this.$router.replace({ query: null });
            } else {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: response_data_fix.data.message,
              });
            }
            Swal.close();
            this.getJadwalPeserta();
          })
          .catch((errors) => {
            const message = errors.response.data.data?.message;
            const site = errors.response.data.data?.site;
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: message,
              showCancelButton: false,
              confirmButtonText: "Oke",
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.href = site;
              }
            });
          });
      } else if (localStorage.access_token_peserta) {
        this.nama_peserta = localStorage.nama_peserta;
        this.jabatan_peserta = localStorage.jabatan_peserta;
        this.data_peserta = JSON.parse(localStorage.data_peserta);
        this.isSimulasi = localStorage.getItem("is_simulasi") == "true";
        this.getJadwalPeserta();
      } else {
        Swal.fire({
          icon: "error",
          title: "Terjadi kesalahan",
          text: "Silahkan login ulang",
          timer: 3000,
        }).then((response) => {
          console.log(response);
          history.forward();
        });
      }
    },

    async getJadwalPeserta() {
      Swal.fire({
        title: "Loading...",
        allowOutsideClick: false,
        showConfirmButton: false,
        onBeforeOpen: () => {
          Swal.showLoading();
        },
      });
      var config_axios = {
        method: "get",
        url: process.env.VUE_APP_BACKEND_URL_VERSION + "peserta/jadwal-peserta",
        params: {
          nip: localStorage.nip_peserta,
          token_jadwal: localStorage.token_jadwal,
        },
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token_peserta,
        },
      };
      await axios(config_axios)
        .then(async (response) => {
          let response_data_fix = response.data;
          if (response.data.meta.code == 200) {
            this.dataListJadwal = response.data.data;
            if (
              this.dataListJadwal.length > 0 &&
              this.dataListJadwal[0].status_jadwal == 2
            ) {
              await Swal.fire({
                icon: "error",
                title:
                  "Jadwal telah selesai dan pastikan file patch SEB sudah sesuai jadwal pelaksanaan",
              }).then(async (result) => {
                if (result.isConfirmed) {
                  await this.logout();
                }
              });
            }
            this.isDone = false;
            await this.getInfoUjian(
              this.dataListJadwal.length
                ? this.dataListJadwal[0].idjadwal_pelaksanaan
                : ""
            );
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response_data_fix.data.message,
            });
          }
          Swal.close();
        })
        .catch((errors) => {
          console.log(errors);
          Swal.close();
          if (errors.response.status == 403) {
            let timerInterval;
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Silahkan Login Ulang",
              timer: 2000,
              timerProgressBar: true,
              showCancelButton: false,
              showConfirmButton: false,
              willClose: () => {
                clearInterval(timerInterval);
              },
            }).then((result) => {
              if (result.dismiss === Swal.DismissReason.timer) {
                let url =
                  localStorage.app_sso === "catalyst"
                    ? "https://catalyst.pln.co.id?seb=assesmen_hc_plnups"
                    : "https://sertifikasi.pln-pusdiklat.co.id/cermat/login";
                window.location.href = url;
              }
            });
          }
        });

      await this.toggleFirstBatch();
    },

    formatDate(dateString) {
      const options = {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
      };
      return new Date(dateString).toLocaleDateString(undefined, options);
    },

    hapusLocalStorage() {
      Swal.fire({
        icon: "question",
        title: "Anda yakin akan logout ?",
        showCancelButton: true,
        confirmButtonText: "Ya",
        cancelButtonText: "Tidak",
      }).then((response) => {
        if (response.isConfirmed) {
          this.logout();
        }
      });
    },
    async logout() {
      let token_jadwal = localStorage.token_jadwal ?? "";
      let nip_peserta = localStorage.nip_peserta ?? "";
      const isSimulasi = localStorage.getItem("is_simulasi") == "true";
      const isDemo = localStorage.getItem("is_demo") == "true";
      const isPegawai = this.isPegawai;
      localStorage.removeItem("uniqueId");

      if (isSimulasi || isDemo) {
        localStorage.removeItem("is_simulasi");
        localStorage.removeItem("access_token_peserta");
        localStorage.removeItem("nama_peserta");
        localStorage.removeItem("jabatan_peserta");
        localStorage.removeItem("data_peserta");
        localStorage.removeItem("app_sso");
        localStorage.removeItem("token_jadwal");
        localStorage.removeItem("uniqueId");
        localStorage.removeItem("is_demo");

        // jika demo ujian kembalikan ke halaman dashboard demo
        if (isDemo) {
          sessionStorage.removeItem("informed_consent_shown");
          this.$router.push({ name: "dashboard-demo" });
          return;
        }

        // jika simulasi kemablikan ke halaman kompetensi
        sessionStorage.removeItem("informed_consent_shown");
        this.$router.push({ name: "kompetensi" });
        return;
      }

      if (localStorage.nip_peserta) {
        axios({
          method: "post",
          url: process.env.VUE_APP_BACKEND_URL_VERSION + "auth/logout-sso",
          data: {
            nip: nip_peserta,
          },
          headers: {
            Authorization: "Bearer " + localStorage.access_token_peserta,
          },
        });
      }
      sessionStorage.removeItem("informed_consent_shown");
      localStorage.clear();

      if (isPegawai) {
        this.$router.push({ name: "login-pegawai" });
        return;
      }

      // if (this.app_sso === "catalyst") {
      // let url = "http://[::1]/midpln/catalyst/login/logout?seb=" + token_jadwal; // local
      let url =
        process.env.VUE_APP_CATALYST_URL + "login-peserta?seb=" + token_jadwal; // dev
      // let url = "login/logout?seb=" + token_jadwal; // prod
      window.location.href = url;
      // }
    },
    async toggleFirstBatch() {
      if (this.dataListJadwal.length > 0 && !this.isDone) {
        await this.toggleAccordion(this.dataListJadwal[0].idjadwal_peserta);
        this.popUpInfoUjian();
      }
    },

    async toggleAccordion(id) {
      Swal.fire({
        title: "Loading...",
        allowOutsideClick: false,
        showConfirmButton: false,
      });
      const collapseElement = document.getElementById("collapse-" + id);
      if (collapseElement) {
        // Cek apakah elemen memiliki kelas show
        const hasShowClass = collapseElement.classList.contains("show");
        // Jika sudah memiliki kelas show, hapus kelas tersebut, jika tidak, tambahkan
        if (hasShowClass) {
          Swal.close();
          collapseElement.classList.remove("show");
        } else {
          const selectedJadwal = this.dataListJadwal.find(
            (jadwal) => jadwal.idjadwal_peserta === id
          );
          // Periksa apakah jadwal ditemukan
          if (selectedJadwal) {
            for (const kompetensi of selectedJadwal.list_kompetensi) {
              try {
                // Panggil API untuk mendapatkan data soal
                const response = await axios.get(
                  process.env.VUE_APP_BACKEND_URL_VERSION +
                    "peserta/jadwal-peserta/list-soal-peserta",
                  {
                    params: {
                      id_kompetensi: kompetensi.idkompetensi,
                      idjadwal: selectedJadwal.idjadwal,
                      idjadwal_peserta: selectedJadwal.idjadwal_peserta,
                      level: kompetensi.level_kompetensi_idlevel_kompetensi,
                      is_simulasi: localStorage.getItem("is_simulasi"),
                      uniqueId: localStorage.getItem("uniqueId"),
                    },
                    headers: {
                      Accept: "application/json",
                      Authorization:
                        "Bearer " + localStorage.access_token_peserta,
                    },
                  }
                );
                const responseData = response.data.data;
                console.log(responseData.length);

                if (responseData.length < 1) {
                  kompetensi.status_peserta.status = 0;
                }
              } catch (error) {
                if (error.response && error.response.status === 500) {
                  kompetensi.status_peserta.status = 0;
                  console.log("Error 500: Internal Server Error");
                } else {
                  kompetensi.status_peserta.status = 0;
                  console.log("Error:", error.message);
                }
              }
            }
          }
          Swal.close();
          collapseElement.classList.add("show");
        }
      }
    },
    popUpInfoUjian() {
      Swal.close();
      if (sessionStorage.getItem("informed_consent_shown")) return;

      Swal.fire({
        icon: "info",
        title: "INFORMED CONSENT",
        width: "900px",
        html: `
          <div style="text-align:justify; font-size:12px; margin-bottom:15px;">
            ${this.info_ujian}
          </div>

          <div style="text-align:left; font-size:14px;">
            <label class="d-flex mb-3" style="cursor: pointer; gap: 10px;">
              <input type="checkbox" id="check1" style="width: 20px; height: 20px">
              Saya telah membaca dan memahami keseluruhan informasi yang terdapat dalam Informed Consent
            </label>

            <label class="d-flex" style="cursor: pointer; gap: 10px;">
              <input type="checkbox" id="check2" style="width: 20px; height: 20px">
              Saya menyetujui pernyataan di atas
            </label>
          </div>
        `,
        confirmButtonText: "Saya Mengerti",
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        focusConfirm: false,
        didOpen: () => {
          const confirmBtn = Swal.getConfirmButton();
          confirmBtn.disabled = true;

          const check1 = document.getElementById("check1");
          const check2 = document.getElementById("check2");

          const validateCheckbox = () => {
            confirmBtn.disabled = !(check1.checked && check2.checked);
          };

          check1.addEventListener("change", validateCheckbox);
          check2.addEventListener("change", validateCheckbox);
        },

        preConfirm: () => {
          const check1 = document.getElementById("check1").checked;
          const check2 = document.getElementById("check2").checked;

          if (!check1 || !check2) {
            Swal.showValidationMessage(
              "Anda harus mencentang kedua checkbox terlebih dahulu"
            );
            return false;
          }

          sessionStorage.setItem("informed_consent_shown", "1");
          return true;
        }
      });
    },

    async checkStatusPengerjaanAsesmen(idjadwal, id_jadwal_peserta, idkompetensi) {
      try {
        const response = await axios({
          method: "get",
          url:
            process.env.VUE_APP_BACKEND_URL_VERSION +
            "peserta/jadwal-peserta/cek-status-asesmen-berlangsung",
          params: {
            idjadwal: idjadwal,
            idjadwal_peserta: id_jadwal_peserta,
            idkompetensi: idkompetensi,
          },
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + localStorage.access_token_peserta,
          },
        });
        if (response.data.meta.code === 200) {
          return response.data.data;
        }
        return false;
      } catch (error) {
        console.log("cek bisa masuk error:", error);
        return false;
      }
    },

    async pindahKeHalamanTujuan(
      id_kompetensi,
      id_jadwal_peserta,
      id_jadwal,
      id_jadwal_batch,
      timer,
      level,
      id_status,
      nama_kompetensi
    ) {
      Swal.fire({
        title: "Loading...",
        allowOutsideClick: false,
        showConfirmButton: false,
        onBeforeOpen: () => {
          Swal.showLoading();
        },
      });

      if (!this.isSimulasi) {
        const cekStatus = await this.checkStatusPengerjaanAsesmen(id_jadwal, id_jadwal_peserta, id_kompetensi);
        if (!cekStatus) {
          Swal.fire({
            icon: "warning",
            title: "Tidak Dapat Masuk",
            text: "Terdapat asesmen lain yang sedang dikerjakan. Selesaikan terlebih dahulu sebelum memulai asesmen ini.",
          });
          return;
        }
      }

      Swal.close();
      Swal.fire({
        title: "Pakta Integritas",
        width: "800px",
        html:
          '<div style="display:flex; align-items:center;">' +
          '<div style="margin-left: 10px; width: 100%; font-size: 12px">' +
          '<p style="text-align: justify;">Dengan memperhatikan prinsip integritas dan etika dalam rangka pelaksanaan Asesmen Hard Competency, dengan sepenuh kesediaan dan komitmen saya menyatakan bahwa:</p>' +
          '<ol style="text-align: justify;">' +
          "<li>Saya bersedia mentaati dan melaksanakan semua instruksi dan tata tertib yang telah ditetapkan selama berlangsungnya kegiatan asesmen ini.</li>" +
          "<li>Saya akan menjaga kerahasiaan semua informasi yang saya peroleh selama kegiatan asesmen ini dengan tidak akan menyimpan, memperbanyak maupun mengedarkan soal asesmen yang saya peroleh dalam bentuk apapun melalui media apapun.</li>" +
          "<li>Saya tidak akan terlibat dalam tindakan curang seperti; mencontek, berkomunikasi dengan peserta lain, atau menggunakan bahan yang tidak diizinkan selama kegiatan asesmen ini.</li>" +
          "<li>Saya menerima hasil asesmen ini dan mempercayakan seluruh hasil asesmen untuk dikelola oleh PT PLN (Persero) Pusat Pendidikan dan Pelatihan dan/atau pihak yang terkait.</li>" +
          "<li>Saya bersedia untuk memberikan umpan balik atau evaluasi terhadap proses asesmen ini dengan tujuan untuk meningkatkan kualitas asesmen di masa mendatang.</li>" +
          "</ol>" +
          '<p style="text-align: justify;"><input type="checkbox" id="checkbox" style="width: 20px; height: 20px"> Saya menyatakan bahwa saya telah membaca, memahami dan setuju untuk mematuhi semua poin yang tercantum dalam Pakta Integritas ini. Demikian Pakta Integritas ini saya buat dengan sebenar-benarnya tanpa ada unsur paksaan dari pihak manapun.</p>' +
          "</div>" +
          "</div>",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Lanjutkan",
        preConfirm: () => {
          const checkbox = document.getElementById("checkbox");
          if (checkbox.checked) {
            return true;
          } else {
            Swal.showValidationMessage(
              "Anda harus menyetujui untuk melanjutkan"
            );
            return false;
          }
        },
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: "Loading...",
            allowOutsideClick: false,
            showConfirmButton: false,
            onBeforeOpen: () => {
              Swal.showLoading();
            },
          });
          var config_store_data = {
            method: "put",
            url:
              process.env.VUE_APP_BACKEND_URL_VERSION +
              "peserta/jadwal-peserta/update-jawaban-peserta/" +
              id_status,
            data: {
              id_jadwal: id_jadwal,
              idjadwal_peserta: id_jadwal_peserta,
              idjadwal_batch: id_jadwal_batch,
              idkompetensi: id_kompetensi,
              level: level,
              status: 2,
              // kritik_saran: this.id_jadwal_batch,
            },
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + localStorage.access_token_peserta,
            },
          };
          var config_update_mulai_mengerjakan = {
            method: "put",
            url:
              process.env.VUE_APP_BACKEND_URL_VERSION +
              "peserta/jadwal-peserta/update-mulai-mengerjakan/" +
              id_status,

            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + localStorage.access_token_peserta,
            },
          };
          axios(config_update_mulai_mengerjakan)
            .then(() => {})
            .catch((error) => {
              this.axiosCatchError = error.response.data;
              if (error.response.status == 403) {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Silahkan Login Ulang",
                  timer: 3000,
                  showConfirmButton: false,
                }).then(() => {
                  let url =
                    localStorage.app_sso === "catalyst"
                      ? "https://catalyst.pln.co.id?seb=assesmen_hc_plnups"
                      : "https://sertifikasi.pln-pusdiklat.co.id/cermat/login";
                  window.location.href = url;
                });
              }
              Swal.close();
            });
          axios(config_store_data)
            .then(async () => {
              let countDownBatch = -1;
              const dataBatch = await axios({
                method: "get",
                url:
                  process.env.VUE_APP_BACKEND_URL_VERSION +
                  `referensi/get-batch/${id_jadwal}/${id_jadwal_batch}`,
                headers: {
                  Accept: "application/json",
                  Authorization: `Bearer ${localStorage.access_token}`,
                },
              })
                .then((response) => response.data.data)
                .catch((err) => {
                  console.log("err get batch", err);
                  return false;
                });
              if (dataBatch) {
                countDownBatch = dataBatch.countdown;
              }

              console.log(dataBatch);
              // console.log(response);
              let param_text =
                id_kompetensi +
                "_" +
                id_jadwal_peserta +
                "_" +
                id_jadwal +
                "_" +
                id_jadwal_batch +
                "_" +
                timer +
                "_" +
                nama_kompetensi +
                "_" +
                id_kompetensi +
                "_" +
                level +
                "_" +
                id_status +
                "_" +
                countDownBatch;
              console.log(param_text);
              let my_param = CryptoJS.AES.encrypt(
                param_text,
                "4lfahumaNeEd5ME!"
              ).toString();

              // Menggunakan arrow function untuk mempertahankan konteks this
              Swal.close();
              this.$router.push({
                name: "dashboard-soal",
                query: { soal: my_param },
              });
            })
            .catch((error) => {
              this.axiosCatchError = error.response.data;
              if (error.response.status == 403) {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Silahkan Login Ulang",
                  timer: 3000,
                  showConfirmButton: false,
                }).then(() => {
                  let url =
                    localStorage.app_sso === "catalyst"
                      ? "https://catalyst.pln.co.id?seb=assesmen_hc_plnups"
                      : "https://sertifikasi.pln-pusdiklat.co.id/cermat/login";
                  window.location.href = url;
                });
              }
              Swal.close();
            });
        }
      });
    },

    remidi(
      id_kompetensi,
      id_jadwal_peserta,
      id_jadwal,
      id_jadwal_batch,
      timer,
      level,
      id_status,
      nama_kompetensi
    ) {
      Swal.fire({
        title: "Pakta Integritas",
        width: "800px",
        html:
          '<div style="display:flex; align-items:center;">' +
          '<div style="margin-left: 10px; width: 100%; font-size: 12px">' +
          '<p style="text-align: justify;">Dengan memperhatikan prinsip integritas dan etika dalam rangka pelaksanaan Asesmen Hard Competency, dengan sepenuh kesediaan dan komitmen saya menyatakan bahwa:</p>' +
          '<ol style="text-align: justify;">' +
          "<li>Saya bersedia mentaati dan melaksanakan semua instruksi dan tata tertib yang telah ditetapkan selama berlangsungnya kegiatan asesmen ini.</li>" +
          "<li>Saya akan menjaga kerahasiaan semua informasi yang saya peroleh selama kegiatan asesmen ini dengan tidak akan menyimpan, memperbanyak maupun mengedarkan soal asesmen yang saya peroleh dalam bentuk apapun melalui media apapun.</li>" +
          "<li>Saya tidak akan terlibat dalam tindakan curang seperti; mencontek, berkomunikasi dengan peserta lain, atau menggunakan bahan yang tidak diizinkan selama kegiatan asesmen ini.</li>" +
          "<li>Saya menerima hasil asesmen ini dan mempercayakan seluruh hasil asesmen untuk dikelola oleh PT PLN (Persero) Pusat Pendidikan dan Pelatihan dan/atau pihak yang terkait.</li>" +
          "<li>Saya bersedia untuk memberikan umpan balik atau evaluasi terhadap proses asesmen ini dengan tujuan untuk meningkatkan kualitas asesmen di masa mendatang.</li>" +
          "</ol>" +
          '<p style="text-align: justify;"><input type="checkbox" id="checkbox"> Saya menyatakan bahwa saya telah membaca, memahami dan setuju untuk mematuhi semua poin yang tercantum dalam Pakta Integritas ini. Demikian Pakta Integritas ini saya buat dengan sebenar-benarnya tanpa ada unsur paksaan dari pihak manapun.</p>' +
          "</div>" +
          "</div>",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Uji Ulang",
        preConfirm: () => {
          const checkbox = document.getElementById("checkbox");
          if (checkbox.checked) {
            return true;
          } else {
            Swal.showValidationMessage(
              "Anda harus menyetujui untuk melanjutkan"
            );
            return false;
          }
        },
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: "Loading...",
            allowOutsideClick: false,
            showConfirmButton: false,
            onBeforeOpen: () => {
              Swal.showLoading();
            },
          });
          var config_uji_ulang = {
            method: "put",
            url:
              process.env.VUE_APP_BACKEND_URL_VERSION +
              "peserta/jadwal-peserta/update-remidi/" +
              id_status,

            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + localStorage.access_token_peserta,
            },
          };
          axios(config_uji_ulang)
            .then(() => {})
            .catch((error) => {
              this.axiosCatchError = error.response.data;
              if (error.response.status == 403) {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Silahkan Login Ulang",
                  timer: 3000,
                  showConfirmButton: false,
                }).then(() => {
                  let url =
                    localStorage.app_sso === "catalyst"
                      ? "https://catalyst.pln.co.id?seb=assesmen_hc_plnups"
                      : "https://sertifikasi.pln-pusdiklat.co.id/cermat/login";
                  window.location.href = url;
                });
              }
              Swal.close();
            });
          var config_update_mulai_mengerjakan = {
            method: "put",
            url:
              process.env.VUE_APP_BACKEND_URL_VERSION +
              "peserta/jadwal-peserta/update-mulai-mengerjakan/" +
              id_status,

            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + localStorage.access_token_peserta,
            },
          };
          var config_store_data = {
            method: "put",
            url:
              process.env.VUE_APP_BACKEND_URL_VERSION +
              "peserta/jadwal-peserta/update-jawaban-peserta/" +
              id_status,
            data: {
              id_jadwal: id_jadwal,
              idjadwal_peserta: id_jadwal_peserta,
              idjadwal_batch: id_jadwal_batch,
              idkompetensi: id_kompetensi,
              level: level,
              status: 2,
              // kritik_saran: this.id_jadwal_batch,
            },
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + localStorage.access_token_peserta,
            },
          };
          axios(config_update_mulai_mengerjakan)
            .then(() => {})
            .catch((error) => {
              this.axiosCatchError = error.response.data;
              if (error.response.status == 403) {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Silahkan Login Ulang",
                  timer: 3000,
                  showConfirmButton: false,
                }).then(() => {
                  let url =
                    localStorage.app_sso === "catalyst"
                      ? "https://catalyst.pln.co.id?seb=assesmen_hc_plnups"
                      : "https://sertifikasi.pln-pusdiklat.co.id/cermat/login";
                  window.location.href = url;
                });
              }
              Swal.close();
            });
          axios(config_store_data)
            .then((response) => {
              console.log(response);
              let param_text =
                id_kompetensi +
                "_" +
                id_jadwal_peserta +
                "_" +
                id_jadwal +
                "_" +
                id_jadwal_batch +
                "_" +
                timer +
                "_" +
                nama_kompetensi +
                "_" +
                id_kompetensi +
                "_" +
                level +
                "_" +
                id_status;
              let my_param = CryptoJS.AES.encrypt(
                param_text,
                "4lfahumaNeEd5ME!"
              ).toString();

              // Menggunakan arrow function untuk mempertahankan konteks this
              Swal.close();
              this.$router.push({
                name: "dashboard-soal",
                query: { soal: my_param },
              });
            })
            .catch((error) => {
              this.axiosCatchError = error.response.data;
              if (error.response.status == 403) {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Silahkan Login Ulang",
                  timer: 3000,
                  showConfirmButton: false,
                }).then(() => {
                  let url =
                    localStorage.app_sso === "catalyst"
                      ? "https://catalyst.pln.co.id?seb=assesmen_hc_plnups"
                      : "https://sertifikasi.pln-pusdiklat.co.id/cermat/login";
                  window.location.href = url;
                });
              }
              Swal.close();
            });
        }
      });
    },

    isDateBetweenStartAndEnd(waktu_mulai, waktu_selesai) {
      const currentDate = new Date();
      const startDate = new Date(waktu_mulai);
      const endDate = new Date(waktu_selesai);
      // console.log(currentDate);
      // console.log(startDate);
      // console.log(endDate);
      console.log(
        "isDateBetweenStartAndEnd",
        currentDate.getTime() >= startDate.getTime() &&
          currentDate.getTime() <= endDate.getTime()
      );
      return (
        currentDate.getTime() >= startDate.getTime() &&
        currentDate.getTime() <= endDate.getTime()
      );
    },
    adaYangSedangDikerjakan(listKompetensi) {
      return listKompetensi.some(
        (k) => k.status_peserta && k.status_peserta.status === 2
      );
    },
  },

  async mounted() {
    await this.saveToLocalStorage();
    // await this.getConfig();
  },
};
</script>

<template>
  <!-- <div class="mym-app-wrapper"> -->
  <!-- NAVBAR -->
  <div class="mym-navbar">
    <div class="mym-navbar-inner">
      <div class="mym-navbar-brand">
        <div class="mym-navbar-logo">
          <img src="/logo_pln.png" alt="Logo PLN" style="height: 40px; object-fit: contain;" />
        </div>

        <div class="mym-navbar-text">
          <div class="mym-navbar-title">Asesmen Hard Competency</div>
          <div class="mym-navbar-subtitle">Unit Pelaksana Sertifikasi</div>
        </div>
      </div>

      <div class="mym-navbar-action">
        <a v-if="isPegawai" href="javascript:void(0)" @click="kembaliKeDashboardPegawai()">
          <i class="fas fa-arrow-left me-2"></i>
          Kembali
        </a>
        <a href="javascript:void(0)" @click="hapusLocalStorage()">
          <i class="fas fa-sign-out-alt me-1"></i>
          Keluar
        </a>
      </div>
    </div>
  </div>

  <!-- MAIN CONTENT -->
  <div class="mym-main-area">
    <div class="mym-content-panel mb-4">
      <div class="mym-section-body">
        <b-tabs class="mym-tab" content-class="mym-tab-content">
          <b-tab title="Jadwal Asesmen" active>
            <div class="row">
              <div class="col-12">
                <div class="mym-card-section">
                  <div
                    v-if="!isDone && dataListJadwal.length === 0"
                    class="alert alert-info w-100 text-center"
                    role="alert"
                  >
                    <i class="fas fa-info-circle me-2"></i>
                    Tidak ada jadwal asesmen yang tersedia.
                  </div>
                  <template v-for="item in dataListJadwal" :key="item.idjadwal_peserta"> 
                    <CardListAssessmen
                      v-if="item.id_mprofesi == null"
                      :batch="item.nama_batch"
                      :data="item"
                      :isSimulasi="isSimulasi"
                      title="Analis Administrasi"
                      code="JF-ADM-001"
                      date="27 Januari 2026"
                      time="09:00 - 10:00"
                      :competencies="[
                        {
                          name: 'Administrasi Perkantoran',
                          level: '3 - Advanced',
                          total_soal: 10,
                        },
                        {
                          name: 'Teknologi Informasi',
                          level: '2 - Practitioner',
                          total_soal: 10,
                        },
                      ]"
                      :pindahKeHalamanTujuan="pindahKeHalamanTujuan"
                      :isDateBetweenStartAndEnd="isDateBetweenStartAndEnd"
                      :adaYangSedangDikerjakan="adaYangSedangDikerjakan"
                    />

                    <CardListAssessmenProfesi 
                      v-else
                      :batch="item.nama_batch"
                      :data="item"
                      :isSimulasi="isSimulasi"
                      title="Analis Administrasi"
                      code="JF-ADM-001"
                      date="27 Januari 2026"
                      time="09:00 - 10:00"
                      :competencies="[
                        {
                          name: 'Administrasi Perkantoran',
                          level: '3 - Advanced',
                          total_soal: 10,
                        },
                        {
                          name: 'Teknologi Informasi',
                          level: '2 - Practitioner',
                          total_soal: 10,
                        },
                      ]"
                      :pindahKeHalamanTujuan="pindahKeHalamanTujuan"
                      :isDateBetweenStartAndEnd="isDateBetweenStartAndEnd"
                      :adaYangSedangDikerjakan="adaYangSedangDikerjakan"
                    />
                  </template>
                </div>
              </div>
            </div>            
          </b-tab>

          <b-tab title="Informasi Peserta">
            <div class="row">
              <div class="col-12 div col-lg-6 scroll-box">
                <h4 class="mym-title-header">DATA PESERTA</h4>

                <div class="mb-4">
                  <div class="mym-label-input">Nama lengkap</div>

                  <div class="mym-input-group">
                    <div class="mym-input-icon">
                      <i class="far fa-user"></i>
                    </div>
                    <div class="mym-input-content">
                      <span class="mym-text">{{ nama_peserta }}</span>
                    </div>
                  </div>
                </div>

                <div class="mb-4">
                  <div class="mym-label-input">NIP</div>

                  <div class="mym-input-group mb-4">
                    <div class="mym-input-icon">
                      <i class="far fa-file-alt"></i>
                    </div>
                    <div class="mym-input-content">
                      <span class="mym-text">{{ data_peserta?.nip }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 col-lg-6 scroll-box">
                <h4 class="mym-title-header">&nbsp;</h4>

                <div class="mb-4">
                  <div class="mym-label-input">Jabatan</div>

                  <div class="mym-input-group mb-4">
                    <div class="mym-input-content">
                      {{data_peserta?.jabatan}}
                    </div>
                  </div>
                </div>

                <div class="mb-4">
                  <div class="mym-label-input">Unit Kerja</div>

                  <div class="mym-input-group mb-4">
                    <div class="mym-input-content">
                      {{ data_peserta?.u_namaunit1 }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <!-- SIMULATION BOX -->
                <div class="mym-sim-box">
                  <div class="mym-sim-header">
                    <div class="mym-sim-icon">
                      <i class="fas fa-play"></i>
                    </div>

                    <div>
                      <div class="mym-sim-title">Video Simulasi Ujian</div>
                      <div class="mym-sim-sub">
                        Latihan mengerjakan ujian tanpa mempengaruhi nilai
                      </div>
                    </div>
                  </div>

                  <div class="mym-sim-desc">
                    Coba simulasi ujian untuk membiasakan diri dengan format
                    soal dan sistem. Hasil simulasi tidak akan tersimpan.
                  </div>

                  <button class="mym-btn-outline">
                    <i class="far fa-play-circle"></i>
                    Mulai Simulasi Ujian
                  </button>
                </div>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
  <!-- </div> -->
</template>
<style scoped>
.nav-head {
  max-width: 1000px !important;
}

.search-pad {
  padding-left: 5px !important;
}

.input-group {
  display: flow;
}

.search-box {
  display: flow;
  align-items: center;
  background-color: #f8f8fb;
  border-radius: 40px;
}

.search-icon {
  position: static;
  line-height: 30px;
}

.search-input input {
  width: -webkit-fill-available;
  border: none;
  outline: none;
  background-color: unset;
  padding: 5px 0px 5px 15px;
}

.position-relative {
  position: relative;
}

.span-notif {
  position: absolute;
  top: 0;
  left: 8px;
  font-size: 8px;
}

.icon-notif {
  position: relative;
  top: 5px;
}

.nav-pills .nav-link {
  border-radius: 5rem;
}

.rounded-button {
  width: 100%;
  padding: 10px;
  border: none;
  /* Warna latar belakang sesuaikan dengan kebutuhan */
  color: #fff;
  /* Warna teks sesuaikan dengan kebutuhan */
  font-size: 16px;
  /* Ukuran font sesuaikan dengan kebutuhan */
  cursor: pointer;
  outline: none;
}
</style>
